"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureCtx = ensureCtx;
exports.ensurePoint = ensurePoint;
exports.ensureScriptable = ensureScriptable;
exports.ensureTwoPoints = ensureTwoPoints;
/**
 * Некоторые поля в конфиге графика типизированы не полностью.
 * Большинство полей в конфиге являются Scriptable. Но в типизации поля прописаны как просто значения
 * Используя функцию ensureScriptable (под свою ответственность), мы утверждаем, что мы вручную убедились,
 * что оригинальная типизация неверна, и на самом деле можно использовать функцию, возвращающую подходящее значение
 * */
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
function ensureScriptable(fn) {
  return fn;
}

/**
 * Когда работаем с Scriptable полями в конфиге графика, то в кач-ве аргумента функции принимают контекст (ctx)
 * Во всех случаях, в прототипе объекта ctx есть поле chart, имеющее тип Chart (из 'chart.js')
 * Но у нас Chart имеет определенную типизацию для datasets
 * @see TCustomChartDataset
 * Утилита помогает утвердить тип ctx, указывая, что он является IBaseContext
 * */
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
function ensureCtx(ctx) {
  if (!ctx.chart) {
    throw new Error();
  }
  return ctx;
}

/**
 * Используя функцию под свою ответственность, мы утверждаем, что переданная точка point является IDatasetItem
 * */
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
function ensurePoint(point) {
  if (!point) {
    throw new Error();
  }
  return point;
}

/**
 * Используя функцию под свою ответственность, мы утверждаем, что одна из переданных точек является IDatasetItem
 * */
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
function ensureTwoPoints(point1, point2) {
  if (!(point1 || point2) || point2 && point1) {
    throw new Error();
  }
  return point1 || point2;
}